import { db } from '../../services/db'
import { CustomThemeType } from '../../utils/types'

export const useCustomTheme = () => {
  const registerCustomTheme = async (data: CustomThemeType) => {
    await db.credentials.clear()

    await db.customTheme.add(data)
  }

  const getCustomTheme = async () => {
    const theme = await db.customTheme.toArray()

    return theme.length ? theme[0] : null
  }

  return {
    register: registerCustomTheme,
    getData: getCustomTheme,
  }
}
